import { DetailTask } from '@/pages/task/DetailTask';
import { DiagramTask } from '@/pages/task/DiagramTask';
import { HistoryTask } from '@/pages/task/HistoryTask';
import { MyTask } from '@/pages/task/MyTask';
import { TasklistMyTask } from '@/pages/tasklist/TasklistMyTask';
import { RouteObject } from 'react-router-dom';

const myTaskRoute: RouteObject[] = [
  {
    path: 'my-task',
    element: <MyTask />,
    children: [
      { path: ':bpmnProcessId/:instanceID/:elementID/:processInstanceID', element: <DetailTask /> },
      { path: ':bpmnProcessId/:instanceID/:elementID/:processInstanceID/history', element: <HistoryTask /> },
      { path: ':bpmnProcessId/:instanceID/:elementID/:processInstanceID/bpmn', element: <DiagramTask /> },
    ],
  },
  {
    path: 'tasklist',
    // element: <MyTask />,
    children: [
      { path: ':processName', element: <TasklistMyTask /> },
      { path: ':bpmnProcessId/:instanceID/:elementID/:processInstanceID/history', element: <HistoryTask /> },
      { path: ':bpmnProcessId/:instanceID/:elementID/:processInstanceID/bpmn', element: <DiagramTask /> },
    ],
  },
];

export default myTaskRoute;
